<template>
  <div>
    <b-row>
      <b-col>
        <label>Status</label>
      </b-col>
      <b-col>
        {{ status }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label>Provider</label>
      </b-col>
      <b-col>
        {{ provider }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label>Merchant ID</label>
      </b-col>
      <b-col>
        {{ merchantid }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label>Token Expires</label>
      </b-col>
      <b-col>
        {{ tokenExpires }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="operation-buttons">
          <div>
            <b-btn
              id="refresh-token-button"
              :class="{ disabled: operationsRunning }"
              :disabled="operationsRunning"
              variant="primary"
              @click="refreshAuthToken"
            >
              Refesh Authorization
            </b-btn>
            <span class="spinner">
              <b-spinner
                v-if="refreshToken"
                small
                variant="primary"
              />
            </span>
            <b-tooltip
              target="refresh-token-button"
              placement="bottom"
              triggers="hover"
            >
              Refresh the authorization token which will extend the authorization period for another 30 days.
            </b-tooltip>
          </div>
          <div>
            <b-btn
              id="revoke-token-button"
              :class="{ disabled: operationsRunning }"
              :disabled="operationsRunning"
              variant="danger"
              @click="revokeAuthToken"
            >
              Revoke Authorization
            </b-btn>
            <div class="spinner">
              <b-spinner
                v-if="revokeToken"
                small
                variant="secondary"
              />
            </div>

            <b-tooltip
              target="revoke-token-button"
              placement="bottom"
              triggers="hover"
            >
              This will revode the authorization token and disable square payments until another connection is made.
            </b-tooltip>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'square-payments-oauth2-service-connected',
  data: function() {
    return {
      refreshToken: false,
      revokeToken: false
    }
  },
  computed: {
    status: function() {
      return this.$store.getters['square/isConnected'] ? 'Service Connected' : 'Not Connected'
    },
    provider: function() {
      return this.$store.state.square.mode === 'development' ? 'Square Sandbox' : 'Square Live'
    },
    merchantid: function() {
      return this.$store.state.square.site_settings.merchantid
    },
    tokenExpires: function() {
      return this.$store.getters['square/isConnected'] ? dayjs(this.$store.getters['square/tokenExpires']).format('DD MMM YYYY - hh:mm') : '--'
    },
    operationsRunning: function() {
      return this.refreshToken || this.revokeToken
    }
  },
  methods: {
    reloadConnectionStatus: function() {
      this.loading = true
      this.$store.dispatch('square/getIsConnected', { force: true })
        .catch(err => {
          this.loading = false
          this.$emit('error', err)
        })
        .finally(_ => {
          this.loading = false
        })
    },
    refreshAuthToken: function() {
      this.refreshToken = true
      this.$store.dispatch('square/refreshAuthToken')
        .then(_ => {
          this.refreshToken = false
        })
        .catch(err => {
          this.refreshToken = false
          this.$emit('error', err)
        })
    },
    revokeAuthToken: function() {
      this.revokeToken = true
      this.$store.dispatch('square/revokeAuthToken')
        .then(_ => {
          this.revokeToken = false
          setTimeout(_ => {
            this.reloadConnectionStatus()
          }, 1000)
        })
        .catch(err => {
          this.revokeToken = false
          this.$emit('error', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .operation-buttons {
    padding: 2.2rem 0;
    display: flex;
    flex-direction: row;
    gap: 2.2rem;
    justify-content: left;

  .spinner {
    margin-left: 1rem;
  }

  }
</style>
